import { ChevronsLeftIcon, ChevronsRightIcon } from "lucide-react";
import { FC } from "react";
import { useSkyViewStore } from "~/features/skyView/store";
import { useMobile } from "~/hooks/use-mobile";

type ExpandableControlProps = {};

export const ExpandableControl: FC<ExpandableControlProps> = () => {
  const { isExpanded, toggleExpanded } = useSkyViewStore();
  const { isMobile } = useMobile();

  if (isMobile) {
    return null;
  }

  return (
    <div
      className={
        "w-3 h-screen relative border-r border-l border-border flex items-center justify-center cursor-pointer hover:bg-accent"
      }
      onClick={toggleExpanded}
    >
      {isExpanded ? (
        <ChevronsRightIcon className="w-2 h-2" />
      ) : (
        <ChevronsLeftIcon className="w-2 h-2" />
      )}
    </div>
  );
};
